import dayjs from "dayjs"
import { APP_LOCALE } from "@constants"
import isBetween from "dayjs/plugin/isBetween"
const plugins = [isBetween]

function loadPlugins() {
  plugins.map(dayjs.extend)
}

function loadLocale() {
  switch (APP_LOCALE) {
    case "en":
      import("dayjs/locale/en.js")
      break
    case "ja":
    default:
      import("dayjs/locale/ja.js")
      break
  }

  dayjs.locale(APP_LOCALE)
}

loadPlugins()
loadLocale()
